// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__3Hw6U","selected":"Chip_selected__2u5vl"};